import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";
import NewExercisePage from "./components/NewExercisePage";
import "bootstrap/dist/css/bootstrap.min.css";
import ManagerErrorPage from "./components/ManagerErrorPage";
import { library } from "@fortawesome/fontawesome-svg-core";

import "./scss-utils/utils/_typography.scss";
import "./index.scss";

import { I18nextProvider } from "react-i18next";

import { i18ninit } from "./translations";
import { faSpinner, faTimes, faLock } from "@fortawesome/free-solid-svg-icons";
library.add(faSpinner, faTimes, faLock);

i18ninit().then(i18n => {
  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <I18nextProvider i18n={i18n}>
          <Route exact path="/cviceni/:slug" component={NewExercisePage} />
          <Route exact path="/chyba/:status" component={ManagerErrorPage} />
        </I18nextProvider>
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root")
  );
});
